import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const TableRegitersControl = ({ title, reactTableData }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        withSearchEngine,
        placeholder: 'Buscar Paciente',
        manualPageSize: [5, 10, 15, 20]
    };

    const columnsData = [
        {
            Header: "Fecha Admisión",
            accessor: 'fecha_admision',
            Cell: row => (
                <label>
                    {row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}
                </label>
            )
        },
        {
            Header: "Registro",
            accessor: 'id_admision',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Entidad",
            accessor: 'entidad',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Paciente",
            accessor: 'paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Servicio",
            accessor: 'servicio',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Recibo de Caja",
            accessor: 'recibo_caja',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Copago",
            accessor: 'copago',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Causa de Rechazos",
            accessor: 'causa_rechazos',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Firma del Doctor",
            accessor: 'firma_doctor',
            Cell: row => (
                <div style={{width: '165px'}}>
                    <img style={{ width : '100%'}} src={`${process.env.REACT_APP_PUBLIC_URL}${row.value}/${sessionStorage.getItem('token')}`} altclassName="img-fluid" alt="Responsive image" />
                </div>
            )
        },
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

TableRegitersControl.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default TableRegitersControl;
